import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Crown, Check } from "lucide-react";
import { toast } from "sonner";

export default function Membership() {
  const { user, refresh } = useAuth();
  const [plans, setPlans] = useState([]);
  const [mine, setMine] = useState(null);

  const reload = () => {
    api.get("/membership/plans").then(r=>setPlans(r.data));
    if (user) api.get("/me/membership").then(r=>setMine(r.data));
  };
  useEffect(() => { reload(); }, [user]);

  const subscribe = async (id) => {
    try { await api.post(`/membership/subscribe/${id}`); toast.success("Membership active!"); await refresh(); reload(); }
    catch(e){toast.error(apiErr(e));}
  };

  return (
    <div className="mx-auto max-w-5xl px-4 sm:px-6 pt-6">
      <h1 className="h-font text-3xl font-bold flex items-center gap-2"><Crown size={22} className="text-[#FFD700]"/> Jixxeo Membership</h1>
      <p className="text-white/60 mt-2">Unlock premium platform benefits. Pay with coins — no ads, ever.</p>
      {mine?.plan_id && (
        <div className="mt-4 inline-flex items-center gap-2 px-3 py-2 rounded-full bg-[#FFD700]/15 text-[#FFD700] border border-[#FFD700]/40 text-sm font-bold">
          <Check size={14}/> Active plan: {mine.plan_id} · expires {mine.expires ? new Date(mine.expires).toLocaleDateString() : '—'}
        </div>
      )}
      <div className="grid md:grid-cols-2 gap-4 mt-6">
        {plans.filter(p=>p.active).map(p=>(
          <div key={p.id} data-testid={`plan-${p.id}`} className="rounded-2xl border border-white/10 bg-gradient-to-br from-white/5 to-transparent p-6">
            <div className="h-font text-2xl font-extrabold">{p.name}</div>
            <div className="text-[#FFD700] font-bold mt-1">{p.coins_per_month} coins / month</div>
            <ul className="mt-4 space-y-2">
              {p.benefits.map((b,i)=>(<li key={i} className="text-sm flex items-center gap-2"><Check size={14} className="text-[#08D9D6]"/>{b}</li>))}
            </ul>
            <button onClick={()=>subscribe(p.id)} data-testid={`sub-plan-${p.id}`}
                    className="jx-btn mt-5 w-full h-11 rounded-full bg-[#FFD700] text-black font-extrabold hover:brightness-110">Subscribe</button>
          </div>
        ))}
      </div>
    </div>
  );
}
